import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Seal from "@/components/Seal";

// Handles the Emergent Google OAuth return: {origin}/dashboard#session_id=...
export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      try {
        if (sessionId) await loginWithGoogleSession(sessionId);
      } catch (e) {
        // fall through to dashboard; ProtectedRoute will redirect to /login if needed
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/dashboard", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white">
      <Seal size={44} />
      <div className="flex items-center gap-2 text-navy-800"><Loader2 className="h-5 w-5 animate-spin text-wgreen-600" /> Signing you in…</div>
    </div>
  );
}
